module.exports = __webpack_public_path__ + "img/quoc_huy_VN.6adc72bc.png";